import { useState } from "react"

import { avg, fmtAns, F } from "./functions"
import { useEffect } from "react"

export default function Average({setPriceAndResultFromAvg}) {
    const [a, setA] = useState(0)
    const [b, setB] = useState(0)
    const [average, setAverage] = useState(0)

    useEffect(() => {
        setAverage(avg(F(a), F(b)))
    }, [a, b])

    const setGlobals = () => {
        setPriceAndResultFromAvg({p: average, r: F(a)})
    }

    return (
        <div className="mb-3">
            <div className="mb-5">
                <div className="form-group mb-4">
                    <label>Num A {setPriceAndResultFromAvg && "/high"}</label>
                    <input type="number" className="form-control" step="0.0000001" value={a} onChange={(e) => setA(e.target.value)} />
                </div>
                <div className="form-group mb-4">
                    <label>Num B {setPriceAndResultFromAvg && "/low"}</label>
                    <input type="number" className="form-control" step="0.0000001" value={b} onChange={(e) => setB(e.target.value)} />
                </div>
            </div>
            <button className="btn btn-secondary w-100 text-center text-decoration-underline py-3" disabled={!Boolean(setPriceAndResultFromAvg)} onClick={setGlobals}>
                {fmtAns(average)}
            </button>
        </div>
    )
}